<template>
  <div class="my_settings">
    <div class="container">
      <div class="row">
        <div class="col-md-2 p-0">
          <sidebar />
        </div>
        <div class="col-md-10 px-5 my_settings__wrapper">
          <div class="my_settings__body">
            <div class="my_settings__body--title">AYARLARIM</div>
            <p>Bu bölümde hesabınızla ilgili bilgilerinizi düzenleyebirlisiniz.</p>
            <div class="my_settings__form">
              <div class="row mb-4">
                <div class="col-md-6 my_settings__input-wrapper">
                  <label for>İsim</label>
                  <input
                    class="my_settings__form--input"
                    type="text"
                    placeholder="İsim"
                    v-model="model.first_name"
                  />
                </div>
                <div class="col-md-6 my_settings__input-wrapper">
                  <label for>Soyisim</label>
                  <input
                    class="my_settings__form--input"
                    type="text"
                    placeholder="Soyisim"
                    v-model="model.last_name"
                  />
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-md-6 my_settings__input-wrapper">
                  <label for>Telefon Numarası</label>
                  <div class="d-flex">
                    <multiselect
                      v-model="country_phone_code"
                      :options="phoneCountryCodesObj"
                      class="rounded-0 my_settings__form--input mr-3"
                      :multiple="false"
                      :close-on-select="true"
                      :hide-selected="false"
                      :preserve-search="true"
                      selectedLabel
                      select-label
                      deselectLabel
                      placeholder
                      label="label"
                      track-by="name"
                    >
                      <template slot="singleLabel" slot-scope="props">
                        +{{ props.option.name }}
                      </template>
                    </multiselect>
                    <the-mask
                      class="my_settings__form--input"
                      :mask="['### ### ## ##']"
                      placeholder="Telefon Numarası"
                      v-model="model.phone_number"
                      v-if="country_phone_code.name == 90"
                    />
                    <input
                      type="text"
                      v-model="model.phone_number"
                      v-if="country_phone_code.name != 90"
                      class="my_settings__form--input"
                      placeholder="Telefon Numarası"
                    >
                  </div>
                </div>
                <div class="col-md-6 my_settings__input-wrapper">
                  <label for>Diğer Telefon Numarası</label>
                  <div class="d-flex">
                    <the-mask
                      class="my_settings__form--input"
                      :mask="['### ### ## ##']"
                      placeholder="Diğer Telefon Numarası"
                      v-model="model.extra_phone_number"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 my_settings__input-wrapper w-100">
                  <label for>Adres</label>
                  <textarea
                    class="my_settings__form--input"
                    rows="8"
                    style="width: 100%"
                    v-model="model.address"
                  ></textarea>
                </div>
                <div class="col-md-6 my_settings__input-wrapper">
                  <label for>E-Posta</label>
                  <input
                    class="my_settings__form--input"
                    type="text"
                    placeholder="E-Posta"
                    v-model="model.email"
                  />
                  <div class="text-right mt-5">
                    <button class="button button__red" @click="updateSettings">BİLGİLERİ GÜNCELLE</button>
                  </div>
                </div>
              </div>

              <div class="row mt-5 my_settings__input-wrapper">
                <div class="col-md-4">
                  <label for>Eski Şifre</label>
                  <input
                    class="my_settings__form--input"
                    type="password"
                    placeholder="Eski  Şifre"
                    v-model="password.old_password"
                  />
                </div>
                <div class="col-md-4">
                  <label for>Yeni Şifre</label>
                  <input
                    class="my_settings__form--input"
                    type="password"
                    placeholder="Yeni Şifre"
                    v-model="password.new_password"
                  />
                </div>
                <div class="col-md-4">
                  <label for>Yeni Şifre Tekrar</label>
                  <input
                    v-model="password.new_password_confirmation"
                    class="my_settings__form--input"
                    type="password"
                    placeholder="Yeni Şifre Tekrar"
                  />
                </div>
              </div>
              <div class="mt-5 text-right">
                <button
                  class="button button__red password__btn"
                  @click="updatePassword"
                >ŞİFREYİ GÜNCELLE</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { TheMask } from 'vue-the-mask'
import Swal from 'sweetalert2'
import Sidebar from '@/components/Sidebar.vue'

export default {
  name: 'Settings',
  data() {
    return {
      phoneCountryCodesObj: [],
      model: {
        first_name: '',
        last_name: '',
        phone_number: '',
        extra_phone_number: '',
        address: '',
        email: ''
      },
      password: {
        old_password: '',
        new_password: '',
        new_password_confirmation: ''
      },
      country_phone_code: {
        id: '90',
        name: '90',
        label: '+90'
      }
    }
  },
  methods: {
    checkData() {
      const data = { ...this.model }
      data.country_phone_code = this.country_phone_code.name
      if (!data.address) delete data.address
      return data
    },
    validatePassword() {
      let isValid = true
      const p = this.password

      if (p.new_password !== p.new_password_confirmation) {
        isValid = false
        Swal.fire('Hata!', 'Yeni şifre alanları uyuşmuyor.', 'error')
      }

      if (!p.new_password_confirmation) {
        isValid = false
        Swal.fire('Hata!', 'Yeni şifre tekrar alanı boş olamaz!', 'error')
      }

      if (!p.new_password) {
        isValid = false
        Swal.fire('Hata!', 'Yeni şifre alanı boş olamaz!', 'error')
      }

      if (!p.old_password) {
        isValid = false
        Swal.fire('Hata!', 'Eski şifre alanı boş olamaz', 'error')
      }

      return isValid
    },

    updatePassword() {
      if (this.validatePassword()) {
        this.$http
          .put('me/password-change', this.password)
          .then(() => {
            Swal.fire(
              'Başarılı',
              'Kullanıcı bilgileri başarıyla güncellendi.',
              'success'
            )
          })
          .catch(() => {
            Swal.fire(
              'Hata!',
              'Eski şifrenizi yanlış girdiniz.',
              'error'
            )
          })
      }
    },
    updateSettings() {
      const data = this.checkData()
      this.$http.put('me/settings', data).then(() => {
        Swal.fire({
          title: 'Bilgileriniz başarıyla güncellendi.',
          type: 'success',
          showCancelButton: false,
          confirmButtonText: 'Tamam'
        })
      })
    }
  },
  components: {
    Sidebar,
    Multiselect,
    TheMask
  },
  created() {
    this.$http.get('me/settings').then((res) => {
      const { data } = res.data

      this.model.first_name = data.first_name
      this.model.last_name = data.last_name
      this.model.phone_number = data.phone_number
      this.model.address = data.address
      this.model.extra_phone_number = data.extra_phone_number
      this.model.email = data.email
      this.country_phone_code.label = `+${data.country_phone_code}`
      this.country_phone_code.id = data.country_phone_code
      this.country_phone_code.name = data.country_phone_code
    })
    this.loadCountries()
  }
}
</script>
